var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","height":_vm.size + 'px',"viewBox":"0 -960 960 960","width":_vm.size + 'px',"fill":"currentColor"}},[_c('path',{attrs:{"d":"M440-80v-647L256-544l-56-56 280-280 280 280-56 57-184-184v647h-80Z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }